module.exports = __webpack_public_path__ + "static/img/f-icon020.83f90ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/f-icon020.png
// module id = WsoZ
// module chunks = 10